module.exports = __webpack_public_path__ + "img/wsczzhjkyypt3.4113c44b.png";